import React, { useState, useEffect } from 'react'
import { useLocation, useParams, Link } from "react-router-dom";
import { getSearchApi, getSearchBySubApi, getSearchWithCatApi, getSearchByCatApi } from '../../../../api/search';
import { errorModal } from '../../../Alerts/Alerts';
import Spinner from 'react-bootstrap/Spinner';
import InfoSearch from '../InfoSearch';
import moment from 'moment';
import Pagination from "react-js-pagination";


export default function ListSearch(props) {
    const [ search, setResultSearch ] = useState([]);
    const [ stateData, setStateData ] = useState({});
    const [ currentPage, setCurrentPage] = useState(1);
    const [ postsPerPage ] = useState(10);
    const [ state, setState] = useState([]);
    const [ reloadState, setReloadState ] = useState(false);
    const location = useLocation();
    const { url } = useParams();
    const [ loading, setLoading] = useState(0);

    useEffect(() => {
        if(location.state){
            setStateData(location.state[0]);
            setState(location.state[0])
            setReloadState(false);
        }
    }, [location]);

    useEffect(() => {
        if(state.data ===0 && state.id_cat ===0 && state.id_sub !==0){
            setLoading(1);
            getSearchBySubApi(state.id_sub)
            .then(response => {
                if (response?.code !== 200){
                    setResultSearch({});
                    setCurrentPage(1);
                }else{
                    setResultSearch(response.resultado);
                    setCurrentPage(1);
                }
                setLoading(0);
            })
            .catch(err => {
                setLoading(0);
                errorModal	("Error", "Error del Servidor.");
            });
        }
        // Busqueda HOME (data=XXX id_cat=XXX id_sub=0)
        if(state.data !==0 && state.id_cat !==0 && state.id_sub ===0){
            setLoading(1);
            getSearchWithCatApi(state.data, state.id_cat)
            .then(response => {
                if (response?.code !== 200){
                    setResultSearch({});
                    setCurrentPage(1);
                }else{
                    setResultSearch(response.resultado);
                    setCurrentPage(1);
                }
                setLoading(0);
            })
            .catch(err => {
                setLoading(0);
                errorModal	("Error", "Error del Servidor.");
            });
        }
        // Busqueda Input Search (data=XXX id_cat=0 id_sub=0)
        if(state.data !==0 && state.id_cat ===0 && state.id_sub ===0){
            setLoading(1);
            getSearchApi(state.data)
            .then(response => {
                if (response?.code !== 200){
                    setResultSearch({});
                    setCurrentPage(1);
                }else{
                    setResultSearch(response.resultado);
                    setCurrentPage(1);
                }
                setLoading(0);
            })
            .catch(err => {
                setLoading(0);
                errorModal	("Error", "Error del Servidor.");
            });
        }

        // Busqueda por Categoria (data=0 id_cat=XXX id_sub=0)
        if(state.data ===0 && state.id_cat !==0 && state.id_sub ===0){
            setLoading(1);
            getSearchByCatApi(state.id_cat)
            .then(response => {
                if (response?.code !== 200){
                    setResultSearch({});
                    setCurrentPage(1);
                }else{
                    setResultSearch(response.resultado);
                    setCurrentPage(1);
                }
                setLoading(0);
            })
            .catch(err => {
                setLoading(0);
                errorModal	("Error", "Error del Servidor.");
            });
        }

        if(state.data ===0 && state.id_cat ===0 && state.id_sub ===0){
            setResultSearch({});
            setCurrentPage(1);
        }
    }, [reloadState, state]);

    if (loading) {
        return (
            <Spinner animation="border" role="status" ></Spinner>
        );
    }

    return (
        <>
            {url ? (
                <InfoSearch url={url} />
            ) : (
                <div>
                    <div className="row mt-5">
                        <div className="col-12">
                            {stateData && stateData.data ? (
                                <>
                                    <h5>Search results: <strong className="text-primary">{stateData.data.replace(/-/gi, ' ')}</strong> </h5>
                                </>
                            ) : (
                                <>
                                    {stateData && stateData.id_sub ? (
                                        <>
                                            <h5>Search by Subcategory. </h5>
                                        </>
                                    ) : (
                                        <>
                                            {stateData && stateData.id_cat ? (
                                                <>
                                                    <h5>Search by Category. </h5>
                                                </>
                                            ) : (
                                                <>
                                                    <h5>You must enter a word in the search field or select a Subcategory.</h5>
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <hr/>
                        {search.length > 0 ? (
                            <>
                                <PreviewSearch 
                                    search={search}
                                    postsPerPage={postsPerPage}
                                    totalPosts={search.length}
                                    setCurrentPage={setCurrentPage}
                                    currentPage={currentPage}
                                />
                            </>
                        ) : (
                            <>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <br/>
                                        <p>No match found.</p>
                                    </div>
                                </div>
                            </>
                        )}
                </div>
            )}
        </>
    )
}

function PreviewSearch(props) {
    const { 
            search,
            postsPerPage,
            totalPosts,
            setCurrentPage,
            currentPage
        } = props;
    
    // Busqueda actual
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    let currentPosts = search.slice(indexOfFirstPost, indexOfLastPost);

    // Cambiar página
    const paginate = pageNumber => setCurrentPage(pageNumber);

    return(
        
        <>
            {Array.from(currentPosts).map((resSearch, index) => {
                return(
                    <div key={index}>
                        
                        <div className="row mt-3">
                            <div className="col-12">
                                <h3 id="responsive-meta-tag">
                                    <Link 
                                        to={"/search/"+resSearch.post.url}    
                                    >
                                        <span className="bd-content-title">{resSearch.post.nm_titulo}</span>
                                    </Link>
                                    
                                </h3>
                                <span className="col-12 p-0 text-right text-secundary fecha-busqueda" >Publication Date: {moment(resSearch.post.fc_creacion).format("DD/MM/YYYY")}</span>
                                <div className="filter-tag-container text-primary">
                                    {resSearch.post && resSearch.post.id_categoria && resSearch.post.id_categoria.nm_categoria ? (
                                        <span>
                                            {"Category: " + resSearch.post.id_categoria.nm_categoria}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                    {resSearch.post && resSearch.post.id_subcategoria && resSearch.post.id_subcategoria.nm_subcategoria ? (
                                        <span>
                                            {" > Subcategory: " + resSearch.post.id_subcategoria.nm_subcategoria}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                        <hr/>
                    </div>
                )
            })}
            <div className='pagination float-right'>
                <Pagination
                    className='pagination float-right'
                    hideFirstLastPages
                    prevPageText='Anterior'
                    nextPageText='Siguiente'
                    activePage={currentPage}
                    itemsCountPerPage={10}
                    totalItemsCount={totalPosts}
                    pageRangeDisplayed={5}
                    onChange={paginate}
                    itemClass="page-item"
                    linkClass="page-link"
                />
            </div>
        </>
        )
}